/**
 * Created by Jew on 7/24/2017.
 */
import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { IdexService } from 'app/idex.service';
import { Router } from '@angular/router';
import { Toast } from 'app/shared/toast/toast';
import { MatSort } from '@angular/material/sort';
import { RestDataSource } from 'app/shared/rest-data-source';
import { SelectionModel } from '@angular/cdk/collections';
import { AdminApi } from '../admin-api';
import { PaginatorComponent } from 'app/shared/paginator';
import { TranslateService } from '@ngx-translate/core';
import { iif } from 'rxjs';

@Component({
   selector: 'app-add-to-site',
   templateUrl: './add-to-site.component.html',
   styleUrls: ['./add-to-site.component.css']
})
export class AddToSiteComponent implements OnInit, AfterViewInit {
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(PaginatorComponent) paginator: PaginatorComponent;
   @ViewChild('wrapper') wrapper: ElementRef;
   @ViewChild('e') e: ElementRef;
   user: any;
   q = '';
   pageIndex = 0;
   pageSize = 50;
   tin: any;
   error: string;
   private timer: any;
   searchFocused: boolean;
   searchResult: string[];
   searchSize = 8;

   displayedColumns = ['select','site_name'];
   siteName: any = '';

   dataSource = new RestDataSource<any>();
   selection = new SelectionModel<any>(true, []);
   selectedRowIndex = 0;

   usernames: any[];
   elements: any[] = [];

   isMember: boolean;
   type: string;
   numOfSearchChar = 2;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any,
      public dialogRef: MatDialogRef<AddToSiteComponent>,
      private api: AdminApi, private translate: TranslateService,
      public service: IdexService, private router: Router, private toast: Toast, public dialog: MatDialog) {
      this.usernames = data.usernames;
      this.isMember = data.isMember;
      if (this.isMember) {
         this.type = 'USER';
      } else {
         this.type = 'GROUP';
      }
      this.user = this.service.user;
   }
   ngAfterViewInit(): void {
      this.onSearch();
   }

   ngOnInit() {
      this.tin = window.localStorage.getItem('tin');
   }

   toggleSelection(row: any) {
      this.dataSource.toggle(row);
   }

   onSearchFocus() {
      this.searchFocused = true;
   }

   onSearchBlur() {
      setTimeout(() => {
         this.searchFocused = false;
      }, 300);
   }

   selectSearchItem(item: any) {
      setTimeout(() => {
         this.searchFocused = false;
      }, 100);
      this.addToSite(item);
   }

   onSearchChange(input: any) {
      this.searchResult = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = input.value.trim();
      if (q.length < this.numOfSearchChar) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         const result = this.elements.filter(e => e.siteName.toLowerCase().includes(q.toLowerCase()));
         if (result && result.length > 0) {
            this.searchResult = result.slice(0,this.searchSize);
         } else {
            this.searchResult = [];
         }
      }, 300);
   }

   onSearch(): void {
      this.e.nativeElement.blur();
      this.q = this.q.trim();
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.clearSelection();
      this.dataSource.setFilter({'tin': this.tin, 'searchText': this.q,'sort': 'site_name' , 'size': this.pageSize, 'page': this.pageIndex});
      this.api.findSite({'tin': this.tin, 'type': this.type},this.usernames)
            .subscribe(
               result => {
                  this.elements = result;
                  let page = this.elements.slice(this.pageIndex * this.pageSize, (this.pageIndex + 1) * this.pageSize);
                  const data = {
                     content: page,
                     totalElements: result.length
                  }
                  this.dataSource.loaded(data);
                  this.dataSource.loadData();
      })
      this.dataSource.changes.subscribe((params: any) => {
         this.sortData(this.elements);
         let page = this.elements.slice(this.pageIndex * this.pageSize, (this.pageIndex+1) * this.pageSize);
         const data = {
            content: page,
            totalElements: this.elements.length
         }
         this.dataSource.loaded(data);
      });
      setTimeout(() => this.dataSource.loadData());
   }

   pageChange(): void {
      if (this.paginator.size !== undefined) {
         this.pageSize = this.paginator.size;
      }
      this.pageIndex = this.paginator.page;
      setTimeout(() => this.dataSource.loadData());
   }

  async addToSites() {
      let cnt = 0;
      for(let username of this.usernames){
         for(let item of this.dataSource.selected){
            await this.api.addToSite(username,item.siteCode,this.isMember);
         }
         ++cnt;
      }
      if (cnt === this.usernames.length){
         this.translate.get('company.add-to-site-success').subscribe(s => {
            this.toast.success(s.toString())
         });
      }
      this.dialogRef.close();
   }

   async addToSite(item: any)  {
      let cnt = 0;
      for(let username of this.usernames){
         await this.api.addToSite(username,item.siteCode,this.isMember);
         ++cnt;
      }
      if (cnt === this.usernames.length){
         this.translate.get('company.add-to-site-success').subscribe(s => {
            this.toast.success(s.toString())
         });
      }
      this.dialogRef.close();
   }

   sortData(data: any[]) {
      data.sort((a: any, b: any) => {
         let comparatorResult = 0;
         comparatorResult = a.siteName.localeCompare(b.siteName);
         return comparatorResult;
      });
     }
}